<template>
  <div :key="standardFamily.id">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'standardFamily',
        ]),
    },
    async beforeRouteUpdate(to, from, next) {
        if (from.params.standardFamilyId !== to.params.standardFamilyId) {
            if (await this.getStandardFamilyInfo(to.params.standardFamilyId)) {
                next();
            }
        } else {
            next();
        }
    },
    methods: {
        ...mapActions({
            getStandardFamilyInfo: 'getStandardFamilyInfo',
        }),
    },
};
</script>
